var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`${_vm.$appPrefix}-head-info-item`]},[_c('Row',[_c('Col',{attrs:{"col":4}},[_vm._t("dt",function(){return [_vm._v(_vm._s(_vm.dt))]})],2),_c('Col',{attrs:{"col":8}},[_vm._t("dd",function(){return [_vm._v(_vm._s(_vm.dd))]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }